import { Route } from '@angular/router';
import { ITenantSettings } from 'src/app/setting/tenant-settings/models/tenant-setting';

/**
 * Whether a route is switched on by the tenant settings. The settings menu and the
 * TenantSettingGuard share this rule, so a hidden menu item is never an enterable page:
 *
 * - `data.tenantSetting`: name of a boolean tenant option that must be on (e.g. 'hasTimeSupplements').
 * - Not declared: the route does not depend on a tenant option.
 *
 * While the settings are not loaded yet, a dependent route counts as switched off.
 */
export function isEnabledByTenantSettings(route: Route, tenantSettings: ITenantSettings | null): boolean {
  const option = route.data?.['tenantSetting'] as keyof ITenantSettings | undefined;

  return !option || !!tenantSettings?.[option];
}
